import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { apiSharedResult } from "../lib/api";
import { ResultCard } from "../components/ResultCard";
import { Loader2, ShieldCheck, ArrowRight } from "lucide-react";

export default function SharedResult() {
  const { id } = useParams();
  const { t } = useLang();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiSharedResult(id)
      .then((d) => active && setResult(d))
      .catch(() => active && setError(true))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [id]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
      {/* Branded header */}
      <div className="mb-6 flex flex-col items-center text-center" data-testid="shared-header">
        <img src="/logo.png" alt="TrustWall" className="h-12 w-12 rounded-xl object-cover" />
        <span className="mt-3 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-blue-700">
          {t("result.sharedView.badge")}
        </span>
        <h1 className="mt-3 text-2xl font-bold text-slate-900 sm:text-3xl">{t("result.sharedView.title")}</h1>
        <p className="mt-2 max-w-xl text-sm text-slate-500">{t("result.sharedView.subtitle")}</p>
      </div>

      {loading && (
        <div className="flex justify-center py-16" data-testid="shared-loading">
          <Loader2 className="h-6 w-6 animate-spin text-blue-700" />
        </div>
      )}

      {error && !loading && (
        <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center text-slate-500" data-testid="shared-notfound">
          {t("result.sharedView.notFound")}
        </div>
      )}

      {result && !loading && (
        <>
          <ResultCard result={result} readOnly />
          <div className="mt-8 flex flex-col items-center gap-3 rounded-3xl border border-blue-200 bg-blue-50 p-6 text-center" data-testid="shared-cta">
            <ShieldCheck className="h-8 w-8 text-[#0D9488]" />
            <p className="text-sm text-slate-600">{t("result.sharedView.subtitle")}</p>
            <Link
              to="/check"
              data-testid="shared-cta-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#1E3A8A] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#1D4ED8]"
            >
              {t("result.sharedView.cta")} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
